import React from 'react';
import styled from 'styled-components';

export type PillTone = 'success' | 'neutral';

const StyledPill = styled.span<{ $tone: PillTone }>`
  font-size: var(--xsmall-font-size);
  font-weight: var(--medium-font-weight);
  line-height: var(--xsmall-line-height);
  white-space: nowrap;
  padding: var(--xxxsmall-padding) var(--xsmall-padding);
  border-radius: var(--grand-border-radius);
  background: ${({ $tone }) =>
    $tone === 'success' ? 'var(--green-pale)' : 'var(--platinum-main)'};
  color: ${({ $tone }) =>
    $tone === 'success' ? 'var(--green-status)' : 'var(--gray-darkest)'};
`;

type AppPillProps = {
  tone?: PillTone;
  className?: string;
  children: React.ReactNode;
};

export const AppPill: React.FC<AppPillProps> = ({
  tone = 'neutral',
  className,
  children,
}) => (
  <StyledPill $tone={tone} className={className}>
    {children}
  </StyledPill>
);
